const PlusIcon = () => (
  <svg
    className="h-4 w-4"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 5v14" />
    <path d="M5 12h14" />
  </svg>
);

const labelClass =
  'flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-primary-dark';

/**
 * Fund Commitments filter bar: Project + Partner + primary action.
 */
const FundCommitmentsFilters = ({
  title,
  description,
  project,
  onProjectChange,
  partner,
  onPartnerChange,
  onFilterChange,
  projectSelectId = 'fund-commitment-project',
  partnerSelectId = 'fund-commitment-partner',
  projects = [],
  isLoadingProjects = false,
  partners = [],
  isLoadingPartners = false,
  primaryAction,
  children,
}) => {
  const handleProjectChange = (e) => {
    onProjectChange?.(e.target.value);
    onFilterChange?.();
  };

  const handlePartnerChange = (e) => {
    onPartnerChange?.(e.target.value);
    onFilterChange?.();
  };

  const renderPrimaryAction = () => {
    if (!primaryAction?.label) return null;
    return (
      <button
        type="button"
        onClick={primaryAction.onClick}
        className={
          'inline-flex items-center gap-2 whitespace-nowrap rounded-xl bg-primary px-4 py-2 ' +
          'text-sm text-text-inverse shadow-md transition ' +
          'hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 ' +
          'disabled:cursor-not-allowed disabled:opacity-60'
        }
        disabled={primaryAction.disabled}
      >
        <PlusIcon />
        {primaryAction.label}
      </button>
    );
  };

  return (
    <div className="rounded-2xl border border-cream/20 bg-white shadow-sm">
      <div className="px-6 py-6 text-sm text-slate-600">
        <p className="text-base font-bold text-primary-dark">{title}</p>
        {description && (
          <p className="mt-2 text-sm text-slate-500">{description}</p>
        )}
        <div className="mt-4 border-t border-primary-dark/20" aria-hidden />

        <div className="mt-6 space-y-6">
          <div className="flex flex-wrap items-end justify-between gap-3">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
              <div>
                <label htmlFor={projectSelectId} className={labelClass}>
                  Project
                </label>
                <select
                  id={projectSelectId}
                  value={project}
                  onChange={handleProjectChange}
                  className="mt-1 w-56 rounded-lg border border-primary-dark/20 bg-gray-50 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-primary-dark focus:ring-1 focus:ring-primary-dark/30"
                  disabled={isLoadingProjects}
                >
                  <option value="">
                    {isLoadingProjects ? 'Loading…' : 'All projects'}
                  </option>
                  {projects.map((p) => (
                    <option key={p._id} value={p._id}>
                      {p.projectCode ? `${p.projectCode} - ` : ''}{p.name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label htmlFor={partnerSelectId} className={labelClass}>
                  Partner
                </label>
                <select
                  id={partnerSelectId}
                  value={partner}
                  onChange={handlePartnerChange}
                  className="mt-1 w-48 rounded-lg border border-primary-dark/20 bg-gray-50 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-primary-dark focus:ring-1 focus:ring-primary-dark/30"
                  disabled={isLoadingPartners}
                >
                  <option value="">
                    {isLoadingPartners ? 'Loading…' : 'All partners'}
                  </option>
                  {partners.map((p) => (
                    <option key={p._id} value={p._id}>
                      {p.acronym ? `${p.acronym} - ` : ''}{p.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {renderPrimaryAction()}
          </div>

          {children}
        </div>
      </div>
    </div>
  );
};

export default FundCommitmentsFilters;
